var map = {
	"./american-burger-app.png": "f7da",
	"./american-burger.jpg": "a726",
	"./asfores.jpg": "59c2",
	"./coderdojo.jpg": "6612",
	"./easyrt2012.jpg": "6fb3",
	"./jobprod.jpg": "8bd1",
	"./mon-confort.jpg": "af15",
	"./quixity.jpg": "c9b4",
	"./rappipage.png": "c55d",
	"./sigma10.jpg": "ff22",
	"./tdb-thermicien.jpg": "2677",
	"./todoenunico.jpg": "e801",
	"./tsirve.png": "1285",
	"./uorder.png": "44b1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3f54";